App.BonusCategoriesEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')

  needs: [ 'bonus-categories', 'bonusCategoriesIndex' ]

  bonusCategoryBinding: 'model'

  isLoading: false
  isColorpickerShown: false

  previewStyle: (->
    bonusCategory = @get('bonusCategory')
    color = bonusCategory.get('bonus_category_color')

    return ''.htmlSafe() unless color
    return "background-color: #{color}".htmlSafe()
  ).property('bonusCategory.bonus_category_color')

  actions:
    cancel: ->
      bonusCategory = @get('bonusCategory')

      if bonusCategory.get('isDirty') or bonusCategory.get('isNew')
        return unless confirm Em.I18n.t 'bonus_category_info.confirm.cancel'
        bonusCategory = @get('bonusCategory')
        bonusCategory.rollback()

      @send('goBackToBonusCategoriesList')
      false

    saveBonusCategory: ->
      @set('isLoading', true)
      bonusCategory = @get('bonusCategory')
      wasNew = bonusCategory.get('isNew')

      statusText = Em.I18n.t "bonus_category_info.notifier.status.#{if wasNew then 'new' else 'old'}"
      bonusCategory.save()
        .then =>
          @set('isLoading', false)
          @transitionToRoute('bonus-categories')
          bonusCategory.reload()
          @get('notifier').pushNotification
            type:     'success'
            title:    Em.I18n.t 'bonus_category_info.notifier.title', text: statusText
            duration: 3000

      false

    deleteBonusCategory: ->
      @set('isLoading', true)
      return unless confirm Em.I18n.t 'bonus_category_info.confirm.delete'
      bonusCategory = @get('bonusCategory')
      bonusCategory.destroyRecord()
        .then =>
          @set('isLoading', false)
          @transitionToRoute('bonus-categories')

      false

    colorChanged: (value) ->
      @set('bonusCategory.bonus_category_color', value)
      @set('isColorpickerShown', false)
      false

    toggleColorpicker: (event) ->
      @toggleProperty('isColorpickerShown')
      false